<template>
  <section class="home">
    <div class="top">
      <div class="t_left" @click="showPopup">
        {{ cityName }}
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACbUlEQVRoQ+3X26tNURTH8c9xCSHkUiS5JLdIHggRItcktwd/gpT/yD8gIQpF5MklyYtyeVDIXSgUQkNz1W7nnL3OmvOkk7VrP+01xxq/33eMMcfuM8w/fcM8f62Af02wJdASyHSgLaFMA7OPtwSyLcwM0BLINDD7+H9BYBbGYhy+4DU+Z1vXf4BRmIGZGIlbA72rDoHVmJy+73AfL4ZQwHQsxXz+LJsncgUcwzwsxjOcw3V8GgIR07ABu7AoEd+RK+A4lmM7fuEiTuI2PhQUEc6vxQFsxhg8x6pcARuxDEdSsDdJxCncLERianJ+H7ZgAu7iAY7mCpiE2diJ/ViBEHEBpwuQqJyP2OH8eNzDWTxMZvWroU4Tx+GYQHNSbR7qEHEJOSQ6na+SD+ejz67gFd7mEug8H428O9VpLomBnL+MR/jeq8fqEqjijE4TaQ+CRDR3lNNgSQzkfCT/GN96JR+/D1ZAFTOHRBHnq0SaCmhKopjzuQJ6kTiTVoDOeyIuqXWpfzZ1TZvaNd9dVk0J1O2Jq/iBKWnOd47KatoMquZLC+iPRIy/uCdilr/EXOzFtnRJVXO+sfOlSuhvJA6mPeY97uBp2i7XIHognD+PLOdLC+gmEWN2Zdpnog9+pj0qVoOgUiXfc873GqW5PdAdv5pOsUEexvr0QNC4ke6LIs4PFYEq7hIEha2pgWMNj8Sv1b1hezk/1ALiH9wCLMTEtHZH+Type8P+awEjEFtsNG0sgl/TyvGxbmJ1nyvdA3XfW+y5VkAxKxsGagk0NK7YsZZAMSsbBmoJNDSu2LGWQDErGwZqCTQ0rtixYU/gN7wplzFX+CKBAAAAAElFTkSuQmCC"
          alt=""
        />
      </div>
      <div style="flex: 1">
        <van-search
          v-model="condition.name"
          placeholder="请输入搜索关键词"
          input-align="center"
          @search="getList"
        />
      </div>
    </div>
    <div class="venue" v-for="item in museumDetail" :key="item.id">
      <div class="venue_left">
        <img :src="picpreFix + item.mainPic" alt="" />
      </div>
      <div class="venue_right">
        <div class="title">{{ item.name }}</div>
        <div class="openTime">
          开放预约时间：{{ item.beginTime }}-{{ item.endTime }}
        </div>
        <div class="address">
          <img
            src="data:image/png;base64,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"
            alt=""
          />{{ item.address }}
        </div>
        <div class="yuyueButton" @click="toOrder(item)">预 约</div>
      </div>
    </div>

    <van-popup v-model="show" position="top" :style="{ height: '50%' }">
      <div class="popup_box">
        <div class="popup_top">
          <div class="popup_top_left">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
            <div>当前选择</div>
          </div>
          <div class="popup_top_right">{{ cityName }}</div>
        </div>

        <div class="popup_title">省市列表</div>

        <div class="popup_content">
          <div
            @click="select('')"
            :class="condition.cityId == '' ? 'popup_city_select' : 'popup_city'"
          >
            全浙江省
          </div>
          <div
            @click="select(item.id, item.name)"
            :class="
              condition.cityId == item.id ? 'popup_city_select' : 'popup_city'
            "
            v-for="item in cityList.cities"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="popup_bottom">
          <div class="Reset">重置</div>
          <div class="Finish" @click="showPopup">完成</div>
        </div>
      </div>
    </van-popup>
  </section>
</template>

<script>
import { List, picpreFix, City, jiemi, Login } from "../api/api";
import { Decrypt, Desensitization, noPassByName } from "../../utils/secret.js";
export default {
  name: "Index",
  data() {
    return {
      condition: {
        provinceId: "471",
        name: "",
        cityId: "",
      },
      cityName: "全浙江省",
      museumDetail: {},
      picpreFix,
      show: false,
      cityList: "",
      userInfor: {},
    };
  },
  created() {
    console.log();
    console.log(decodeURIComponent("%E5%91%A8%E8%B5%A2"), "看解码的名字");
    console.log(this.$route.query);
    this.userInfor.phone = this.$route.query.phone;
    this.userInfor.name = decodeURIComponent(this.$route.query.name);
    this.userInfor.cardNum = this.$route.query.cardNum;
    this.signature = this.$route.query.signature;
    if (this.$route.query.userId) {
      this.userId = this.$route.query.userId.replace(/\"/g, "");
    }

    console.log(this.userId);
    localStorage.setItem("userId", this.userId);
    //    this.zheliban()
    this.getList();
    this.getCity();
  },
  methods: {
    //获取列表
    getList() {
      List(this.condition).then((res) => {
        console.log(res);
        this.museumDetail = res.data.data;
        console.log(this.museumDetail, "ckckck", this.picpreFix);
      });
    },
    //判断是否选中
    select(item, name = "全浙江省") {
      this.cityName = name;
      this.condition.cityId = item;
      this.getList();
    },
    //弹出框
    showPopup() {
      this.show = !this.show;
    },
    toOrder(item) {
      this.$router.push({ path: "/yuyueIndex", query: { museumId: item.id } });
    },
    //获取城市列表yuyu
    getCity() {
      City(this.condition.provinceId).then((res) => {
        this.cityList = res.data.data[10];
        console.log(this.cityList, "看看");
      });
    },

    //浙里办解密
    zheliban() {
      console.log(this.userInfor, "看看浙里办数据");
      this.userInfor.phone = Decrypt(this.userInfor.phone);
      this.userInfor.cardNum = Decrypt(this.userInfor.cardNum);
      this.userInfor.showCardNum = this.userInfor.cardNum.replace(
        /(\d{1})\d*(\d{1})/,
        "$1**************$2"
      );
      this.userInfor.showName = noPassByName(this.userInfor.name);
      console.log(
        this.userInfor.showCardNum,
        "看看脱敏的身份证号",
        this.userInfor.showName,
        "看看脱敏的名字"
      );
      this.userInfor.isSelected = true;
      this.userInfor.master = true;
      //数据解密后进行登录操作
      Login({ openid: this.userId, appId: "ZLB_Iqho1JOVwYgSKzBQy" }).then(
        (res) => {
          console.log(res);
        }
      );
      this.$store.commit("ADDPER", { ...this.userInfor });
      // jiemi({...this.userInfor}).then(res=>{
      //     console.log(res.data.data,'浙里办解密')
      //   res.data.data.isSelected = false;
      //   this.$store.commit('ADDPER',res.data.data)
      // })
    },

    // 设置用户信息埋点
    SetZwUserAplus(userId) {
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_hold", "BLOCK"],
      });
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_nick", this.userInfor.name],
      });
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_id", userId],
      });
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_hold", "START"],
      });
    },
    // 基础信息埋点配置
    SetZwaplus() {
      (function (w, d, s, q, i) {
        w[q] = w[q] || [];
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.id = "beacon-aplus";
        j.src = "https://d.alicdn.com/alilog/mlog/aplus.js?id=202951085";
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "aplus_queue");
      // 如果是私有云部署还需要在上面那段 JS 后面紧接着添加日志域名埋点
      // 通常私有云日志服务端域名类似于：quickaplus-web-api.xxx.com.cn ，具体域名需找交付同学要

      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-rhost-v", "alog.zjzwfw.gov.cn"],
      });
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-rhost-g", "alog.zjzwfw.gov.cn"],
      });
      // 这个会落到 app_key 字段上
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["appId", "60506758"],
      });
      // 单页应用 或 “单个页面”需异步补充 PV 日志参数还需进行如下埋点：
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-waiting", "MAN"],
      });

      // 单页应用路由切换后 或 在异步获取到 pv 日志所需的参数后再执行 sendPV：
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: [
          {
            is_auto: false,
          },
          {
            miniAppId: "izt8cldk+2001830421+exokfd",
            miniAppName: "文旅绿码",
          },
        ],
      });
    },
  },
  mounted() {
    this.SetZwaplus(this.userInfor); //埋点
    this.SetZwUserAplus(this.userInfor);
  },
};
</script>

<style scoped lang="less">
.home {
  overflow: auto;
  padding: 0 30px;
}
.top {
  margin: 20px 0;
  display: flex;
  .t_left {
    display: flex;
    font-size: 23px;
    align-items: center;
    margin-right: 20px;
    img {
      width: 32px;
      height: 32px;
      margin-left: 0.106667rem;
    }
  }
  /deep/.van-search__content {
    background-color: #fff;
    .van-icon-search {
      font-size: 1rem;
    }
    .van-cell {
      font-size: 0.6rem;
    }
  }
}
.venue {
  width: 100%;

  margin-top: 20px;
  border-radius: 20px;
  background-color: white;

  box-sizing: border-box;
  padding: 0.9375rem;
  display: flex;

  .venue_left {
    flex-shrink: 0;

    width: 220px;
    height: 150px;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .venue_right {
    width: 100%;
    box-sizing: border-box;

    .title {
      font-size: 24px;
    }
    .openTime {
      font-size: 18px;
      color: #999999;
      margin-top: 10px;
    }
    .address {
      font-size: 18px;
      color: #999999;
      margin-top: 10px;
      img {
        width: 18px;
        height: 20px;
      }
    }
    .yuyueButton {
      width: 100px;
      height: 40px;
      color: white;
      text-align: center;
      font-size: 24px;
      line-height: 40px;
      border-radius: 30px;
      background-color: #8dc6d6;
      float: right;
      margin-top: 20px;
      margin-right: 0;
    }
  }
}
.popup_box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px;
  .popup_top {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px;

    font-size: 20px;
    border-bottom: 1px solid #e5e5e5;

    .popup_top_left {
      display: flex;
      justify-items: center;

      img {
        width: 20px;
        height: 20px;
        margin-top: 3px;
      }
    }
    .popup_top_right {
      color: #99999a;
    }
  }
  .popup_title {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    margin-top: 20px;
  }
  .popup_content {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    height: 200px;
    flex-wrap: wrap;
    margin-top: 20px;

    .popup_city {
      width: 22%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #f5f5f5;
      font-size: 15px;
      color: #3c3c3d;
      box-sizing: border-box;
      border-radius: 5px;
    }
    .popup_city_select {
      width: 22%;
      height: 40px;
      line-height: 38px;
      text-align: center;
      background-color: #f5f5f5;
      font-size: 15px;
      color: #8dc6d6;
      box-sizing: border-box;
      border-radius: 5px;
      border: 1px solid #8dc6d6;
    }
  }
  .popup_bottom {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    font-size: 24px;

    .Reset {
      width: 280px;
      height: 40px;
      background-color: #f5f5f5;
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
    }

    .Finish {
      width: 280px;
      height: 40px;
      background-color: #8dc6d6;
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }
}
</style>
